import envelope from '../assets/envelope.png'
import github from '../assets/github.png'
import instagram from '../assets/instagram.png'
import linkedin from '../assets/linkedin.png'

const SOCIAL_PROFILES = [
	{
		id: 1,
		link: 'mailto:betriistan@gmail.com',
		image: envelope,
		text: "Connect with me!"
	},
	{
		id: 2,
		link: 'https://www.linkedin.com/in/tristanbennett1',
		image: linkedin,
		text: "Let's link!"
	},
	{
		id: 3,
		link: 'https://www.instagram.com/tr_.stan/?hl=en',
		image: instagram,
		text: "Ready, set, pose!"
	},
	{
		id: 4,
		link: 'https://github.com/tr-stan',
		image: github,
		text: "Check out my code!"
	}
]

export default SOCIAL_PROFILES